import axios, { AxiosInstance, AxiosResponse } from "axios";
import { AllFleetListResponse, AllFleetSummaryResponse, AllFleetListDailySummaryResponse, AllDriverBehaviorReportResponse, DistanceInsightsReportResponse,
  IotReportResponse, HubWiseListResponse, IotTypeResponse,IotTypeListResponse, IotCountResponse,
  CityWiseResponse,
  ClientseResponse,
  BatteryWiseResponse,
  FleetWiseResponse,
  FleetStatusResponse,
  DayWiseStatusResponse,
  AllGpsReportResponse,
  AllFleetLocationResponse,
  AllFleetResponse,
  AllFleetTrackingResponse,
  EvCategoryListResponse,
  AllFleetListDailySummaryResponseDownload,
  AllGpsReportResponseDownload,
  DistanceInsightsReportResponseDownload,
  AllDriverBehaviorReportResponseDownload,
  ClientIdResponse
 } from "../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";

export class FleetDashboardOverviewApi {
  public static api = new FleetDashboardOverviewApi();
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_IOT_DASHBOARD_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  formatDate = (date: Date | null): string | null => {
      if (!date) return null;
  
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Adjust month to be 0-indexed
      const day = String(date.getDate()).padStart(2, "0");
  
      return `${year}-${month}-${day}`;
    };
    

  async getAllFleetSummary(): Promise<AllFleetSummaryResponse> {
    try {
      const response: AxiosResponse<AllFleetSummaryResponse> =
        await this.instance.get(`/fleet-dash/all-fleet-summary`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
 
  async getAllFleetDailySummary(
    qrcode: string,
    page: number,
    limit: number,
    date: string,
   
  ): Promise<AllFleetListDailySummaryResponse> {
    let apiUrl = "/fleet-dash/fleet-summary-report";
    if (qrcode) {
      apiUrl += `?qrcode=${qrcode}`;
    }
    try {
      const response: AxiosResponse<AllFleetListDailySummaryResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:date,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getAllFleetDailySummaryDownload(
    date: string,
    page: number,
    limit: number,
   
   
  ): Promise<AllFleetListDailySummaryResponseDownload | any> {
    let apiUrl = "/fleet-dash/fleet-summary-report";
  
    try {
      const response: AxiosResponse<AllFleetListDailySummaryResponseDownload> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:date,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
 
  async getDriverBehaviorReport(
    search: string,
    start_date:  Date | null,
    end_date:  Date | null,
    page:number,
    limit:number
   
  ): Promise<AllDriverBehaviorReportResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    let apiUrl = "/fleet-dash/rider-behaviour-report";
    if (search) {
      apiUrl += `?search=${search}`;
    }
   
    try {
      const response: AxiosResponse<AllDriverBehaviorReportResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getDriverBehaviorReportDownload(
    search: string,
    start_date:  Date | null,
    end_date:  Date | null,
    page:number,
    limit:number
   
  ): Promise<AllDriverBehaviorReportResponseDownload> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    let apiUrl = "/fleet-dash/rider-behaviour-report";
  
    if (search) {
      apiUrl += `?search=${search}`;
    }
   
    try {
      const response: AxiosResponse<AllDriverBehaviorReportResponseDownload> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getDistanceInsightsReport(
    month: string,
    category: string,
    battery_type:  string,
    qrcode:  string,
    page:number,
    limit:number
   
  ): Promise<DistanceInsightsReportResponse> {
    
    let apiUrl = "/fleet-dash/distance-insights-report";
    if (qrcode) {
      apiUrl += `?qrcode=${qrcode}`;
    }
   
    try {
      const response: AxiosResponse<DistanceInsightsReportResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            month:month,
            category:category,
            battery_type:battery_type,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getDistanceInsightsReportDownload(
    month: string,
    category: string,
    battery_type:  string,
    page:number,
    limit:number
   
  ): Promise<DistanceInsightsReportResponseDownload> {
    
    let apiUrl = "/fleet-dash/distance-insights-report";
   
   
    try {
      const response: AxiosResponse<DistanceInsightsReportResponseDownload | any> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            month:month,
            category:category,
            battery_type:battery_type,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getEvCategoryList(
   
  ): Promise<EvCategoryListResponse> {
    let apiUrl = "/fleet-dash/fleet_category/list";
  
   
    try {
      const response: AxiosResponse<EvCategoryListResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getGpsReport(
    search: string,
    start_date:  Date | null,
    end_date:  Date | null,
    page:  number,
    limit:number
    
   
  ): Promise<AllGpsReportResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    
    let apiUrl = "/fleet-dash/fleet-tracking";
    if (search) {
      apiUrl += `?search=${search}`;
    }
   
   
    try {
      const response: AxiosResponse<AllGpsReportResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getGpsReportDownload(
    search: string,
    start_date:  Date | null,
    end_date:  Date | null,
    page:  number,
    limit:number
    
   
  ): Promise<AllGpsReportResponseDownload | any> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    
    let apiUrl = "/fleet-dash/fleet-tracking";
    if (search) {
      apiUrl += `?search=${search}`;
    }
   
    try {
      const response: AxiosResponse<AllGpsReportResponseDownload> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            page:page,
            limit:limit
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getIotReport(
    hub_name : string,
    category : string,
    page:number,
    limit:number,
    iot_type?: string
   
  ): Promise<IotReportResponse> {
    
    let apiUrl = "/fleet-dash/hubwise-connection-disconnection-report";
   
    try {
      const response: AxiosResponse<IotReportResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            hub_name :hub_name ,
            category:category,
            page:page,
            limit:limit,
            iot_type:iot_type
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getIotReportDownload(
    hub_name : string,
    category : string,
    page:number,
    limit:number,
    iot_type?: string
   
  ): Promise<IotReportResponse> {
    
    let apiUrl = "/fleet-dash/hubwise-connection-disconnection-report";
   
    try {
      const response: AxiosResponse<IotReportResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            hub_name :hub_name ,
            category:category,
            page:page,
            limit:limit,
            iot_type: iot_type
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getHubWiseList(
    start_date:  Date | null,
    end_date:  Date | null,
    iot_type:string,
  ): Promise<HubWiseListResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    let apiUrl = "/fleet-dash/hubwise/counts";
   
    try {
      const response: AxiosResponse<HubWiseListResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            iot_type:iot_type,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getIotType(
    start_date:  Date | null,
    end_date:  Date | null,
    iot_type:string,
   
  ): Promise<IotTypeResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    let apiUrl = "/fleet-dash/iot-type/counts";
   
    try {
      const response: AxiosResponse<IotTypeResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            iot_type:iot_type,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getIotTypeList(
   
  ): Promise<IotTypeListResponse> {
    
    let apiUrl = "/fleet-dash/iot-type/list";
   
    try {
      const response: AxiosResponse<IotTypeListResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getIotCount(
    start_date:  Date | null,
    end_date:  Date | null,
    iot_type:string,
   
  ): Promise<IotCountResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    let apiUrl = "/fleet-dash/status/counts";
   
    try {
      const response: AxiosResponse<IotCountResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            iot_type:iot_type,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getCityWiseCount(
    start_date:  Date | null,
    end_date:  Date | null,
    iot_type:string,
  ): Promise<CityWiseResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    let apiUrl = "/fleet-dash/city-wise/counts";
   
    try {
      const response: AxiosResponse<CityWiseResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            iot_type:iot_type,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getClientWiseCount(
    start_date:  Date | null,
    end_date:  Date | null,
    iot_type:string,
   
  ): Promise<ClientseResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
    let apiUrl = "/fleet-dash/client-wise/counts";
   
    try {
      const response: AxiosResponse<ClientseResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            iot_type:iot_type,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getBatteryWiseCount(
    date:string
  ): Promise<BatteryWiseResponse> {
    
    let apiUrl = "/fleet-dash/battery-type-wise/dist";
   
    try {
      const response: AxiosResponse<BatteryWiseResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            date :date ,
            
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async getFleetWiseCount(
    date:string
   ): Promise<FleetWiseResponse> {
     
     let apiUrl = "/fleet-dash/fleet-type-wise/dist";
    
     try {
       const response: AxiosResponse<FleetWiseResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
           params: {
            date :date,
             
           },
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }
   async getFleetStatusCount(
    start_date:  Date | null,
    end_date:  Date | null,
    iot_type:string,
   ): Promise<FleetStatusResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
     let apiUrl = "/fleet-dash/vehicle-status/counts";
    
     try {
       const response: AxiosResponse<FleetStatusResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
           params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            iot_type:iot_type,
          },
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }
   async getDaywiseCount(
    start_date:  Date | null,
    end_date:  Date | null,
    iot_type:string,
   ): Promise<DayWiseStatusResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
     let apiUrl = "/fleet-dash/day-wise/counts";
    
     try {
       const response: AxiosResponse<DayWiseStatusResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
           params: {
            start_date:formattedStartDate,
            end_date:formattedEndDate,
            iot_type:iot_type,
          },
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }

   async getAllFleetLocation(
    search:  string | null,
    selectCategory:string
   ): Promise<AllFleetLocationResponse> {
    let apiUrl = "/fleet-dash/all-fleet-locations";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    try {
      const response: AxiosResponse<AllFleetLocationResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
           category:selectCategory,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  
  async getAllFleetList(
    search: string,
    category: string,
    page: number
  ): Promise<AllFleetResponse> {
    let apiUrl = "/fleet-dash/all-fleet-list";
    let params: any = {};
  
    if (search) {
      apiUrl += `?search=${search}`;
    } else {
      params.category = category;
      params.page = page;
    }
  
    try {
      const response: AxiosResponse<AllFleetResponse> = await this.instance.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: Object.keys(params).length ? params : undefined, // Only include params if they exist
      });
  
      return response.data;
    } catch (error) {
      console.error("Error fetching fleet list:", error);
      throw error;
    }
  }

  async getAllFleetListDownload(
    category: string,
    page: number,
    limit: number,
  ): Promise<AllFleetResponse> {
    let apiUrl = "/fleet-dash/all-fleet-list";
  
  
    try {
      const response: AxiosResponse<AllFleetResponse> = await this.instance.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        
        params: {
          category:category,
          page:page,
          limit:limit
        },
      });
  
      return response.data;
    } catch (error) {
      console.error("Error fetching fleet list:", error);
      throw error;
    }
  }
  

  async getFleetTracking(
    search:string,
    qr_code:string,
    start_date:Date | null,
    end_date:Date | null

   ): Promise<AllFleetTrackingResponse> {
    const formattedStartDate = start_date ? this.formatDate(start_date) : null;
    const formattedEndDate = end_date ? this.formatDate(end_date) : null;
     let apiUrl = "/fleet-dash/fleet-tracking";
     const searchValue = qr_code ? qr_code : search;

    
     try {
       const response: AxiosResponse<AllFleetTrackingResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
           params: {
            search: searchValue,
            start_date:formattedStartDate,
            end_date:formattedEndDate

          },
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }
  

  getToken() {
    return localStorage.getItem("token");
  }
}
